import AgentAwareAgreement from 'components/Checkout/OrderSummary/OrderTotalSection/AgentAwareAgreement/AgentAwareAgreement';
import { withAgentAwareAgreementProps } from 'viewModel/checkout/orderSummary/orderTotalSection/agentAwareAgreement/withAgentAwareAgreementProps';

export default withAgentAwareAgreementProps(AgentAwareAgreement);
